'use client'

import { useEffect, useState, useMemo } from "react";
import parse from 'html-react-parser';
import { TextAPI } from "@/api/TextAPI";
import styles from './terms.module.scss'

const termsConditionsTextType = 'terms_conditions'
export default function Terms() {

  const [ termsConditionsBodyText, setTermsConditionsBodyText ] = useState("")

  const textAPI = useMemo(() => new TextAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

  useEffect(() => {
    textAPI.getByType(termsConditionsTextType).then(text => text && setTermsConditionsBodyText(text.body))
  }, [textAPI])


  return (
    <div className={styles.terms}>
      { parse(termsConditionsBodyText) }
    </div>
  )
}
